/**
 * 401 / 会话失效登出单飞闸门。
 * 独立模块，避免 request ↔ store 循环依赖。
 */

/** 登出流程是否进行中（toast / navigate 只触发一次） */
let loggingOut = false;

/** 是否正处于会话失效登出流程 */
export function isAuthLoggingOut(): boolean {
  return loggingOut;
}

/** 标记进入登出流程；若已在流程中返回 false */
export function beginAuthLogout(): boolean {
  if (loggingOut) return false;
  loggingOut = true;
  return true;
}

/** 登录成功后复位，允许后续会话再次触发登出 */
export function resetAuthLogoutGate(): void {
  loggingOut = false;
}
